// TODO: Remove implicit assumption that "text" column is primary text column.
export const TEXT_IS_PRIMARY_COLUMN = "text";

export const PLACEHOLDER_DASHES = "– –";

// Internal links
export const HOMEPAGE_LINK = "/";
export const PRICING_PAGE_LINK = "/pricing";
export const PROGRAMMATIC_PAGE_LINK = "/programmatic";
export const ABOUT_PAGE_LINK = "/about";

// Subdomains
export const CAREERS_LINK = "https://careers.humanloop.com";
export const PROGRAMMATIC_DOCS_LINK = "https://docs.programmatic.humanloop.com";
export const HUMANLOOP_DOCS_LINK = "https://docs.humanloop.com";
export const HUMANLOOP_API_DOCS_LINK = "https://docs.humanloop.com/api";
export const HUMANLOOP_APP_LINK = "https://app.humanloop.com";
export const HUMANLOOP_APP_SIGNUP = "https://app.humanloop.com/signup";
export const HUMANLOOP_APP_LOGIN = "https://app.humanloop.com/login";
export const HUMANLOOP_CAREERS_LINK = "https://careers.humanloop.com";

// Socials and marketing
export const GITHUB_LINK = "https://github.com/humanloop";
export const LINKEDIN_LINK = "https://linkedin.com/humanloop";
export const TWITTER_LINK = "https://twitter.com/humanloop";
export const SLACK_LINK =
  "https://join.slack.com/t/humanloop-community/shared_invite/zt-15bpaukat-w99Ns5wyQiuKVPSxyLqHlQ";
export const WAITLIST_LINK = "https://qnar0f4q62y.typeform.com/to/LlpY8vSt";
export const HUMANLOOP_TYPEFORM = "https://qnar0f4q62y.typeform.com/humanloop";

// These sizes are meant to extend the spacings set in tailwind.
export const PANE_BREAKPOINT_2XS = 350;
export const PANE_BREAKPOINT_XS = 475;
